import { render } from "./IconMoon.vue.js?vue&type=template&id=350e6ba6!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconMoon.vue?vue&type=template&id=350e6ba6"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__